var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (figureid, id, link, otp, t, type, username) {
buf.push("<div class=\"main-wrapper\"><header>");
if ( figureid)
{
buf.push("<figure" + (jade.attr("id", id, true, true)) + ">");
if ( link)
{
buf.push("<a" + (jade.attr("href", link, true, true)) + " target=\"_blank\"><svg><use" + (jade.attr("xlink:href", figureid, true, true)) + "></use></svg></a>");
}
else
{
buf.push("<div class=\"svg-wrapper\"><svg><use" + (jade.attr("xlink:href", figureid, true, true)) + "></use></svg></div>");
}
buf.push("</figure>");
}
if ( username)
{
buf.push("<h1>" + (jade.escape(null == (jade_interp = t(type + " welcome user", {username: username})) ? "" : jade_interp)) + "</h1>");
}
else
{
buf.push("<h1>" + (jade.escape(null == (jade_interp = t(type + " welcome anon")) ? "" : jade_interp)) + "</h1>");
}
buf.push("</header><div role=\"region\"><form" + (jade.attr("id", type+"-form", true, true)) + "><p id=\"login-password-tip\" class=\"help\">" + (jade.escape(null == (jade_interp = t(type+" enter your password", {username: username})) ? "" : jade_interp)) + "</p><p class=\"line\"><label for=\"password\" aria-describedby=\"login-password-tip\">" + (jade.escape(null == (jade_interp = t(type + " password")) ? "" : jade_interp)) + "</label><button type=\"button\"" + (jade.attr("title", t("step password show"), true, true)) + " name=\"password-visibility\" class=\"icon password-visibility-icon masked\"></button><input id=\"password\" name=\"password\" type=\"password\" autofocus></p><p class=\"line\">");
if ( otp)
{
buf.push("<label for=\"otp\">" + (jade.escape(null == (jade_interp = t(type + ' otp')) ? "" : jade_interp)) + "</label><input id=\"otp\" name=\"otp\" type=\"number\" autofocus=\"true\" autocomplete=\"off\">");
}
buf.push("</p>");
if ((type=='reset'))
{
buf.push("<progress value=\"1\" max=\"100\" class=\"pw-weak\"></progress>");
}
buf.push("<p class=\"errors\"></p></form></div><footer><div class=\"controls\"><button" + (jade.attr("form", type+"-form", true, true)) + " type=\"submit\">" + (jade.escape(null == (jade_interp = t(type + " submit")) ? "" : jade_interp)) + "</button>");
if ((type=='login'))
{
buf.push("<div class=\"recover\"><span class=\"coz-busy-label\"></span><a href=\"/login/forgot\" class=\"forgot\">" + (jade.escape(null == (jade_interp = t('login recover')) ? "" : jade_interp)) + "</a></div>");
}
buf.push("</div><div class=\"progression\"></div></footer></div>");}.call(this,"figureid" in locals_for_with?locals_for_with.figureid:typeof figureid!=="undefined"?figureid:undefined,"id" in locals_for_with?locals_for_with.id:typeof id!=="undefined"?id:undefined,"link" in locals_for_with?locals_for_with.link:typeof link!=="undefined"?link:undefined,"otp" in locals_for_with?locals_for_with.otp:typeof otp!=="undefined"?otp:undefined,"t" in locals_for_with?locals_for_with.t:typeof t!=="undefined"?t:undefined,"type" in locals_for_with?locals_for_with.type:typeof type!=="undefined"?type:undefined,"username" in locals_for_with?locals_for_with.username:typeof username!=="undefined"?username:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/views/templates/view_auth.jade
// module id = 19
// module chunks = 0